// extracted by mini-css-extract-plugin
module.exports = {"bodyWrapper":"styles__bodyWrapper___4CBIn","buttons":"styles__buttons___Ux7Dt"};